import Switch from '@/components/Switch/Switch'

export { Switch }